import { render, staticRenderFns } from "./supgisComponent.vue?vue&type=template&id=ebe9fc94&scoped=true&"
import script from "./supgisComponent.vue?vue&type=script&lang=js&"
export * from "./supgisComponent.vue?vue&type=script&lang=js&"
import style0 from "./supgisComponent.vue?vue&type=style&index=0&id=ebe9fc94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe9fc94",
  null
  
)

export default component.exports